module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerMedium.3bf0f256.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerMedium.otf
// module id = 1069
// module chunks = 0